const breakPoints = {
  // RESPONSIVE BREAKPOINTS // css var can't be used directly in media query
  bp4k: "112.5em",
  bpLargest: "75em", // 1200px
  bpLarge: "62.5em", // 1000px
  bpMedium: "50em", // 800px
  bpSmall: "37.5em", // 600px
  bpSmallest: "31.25em", // 500px
};

export default breakPoints;
